import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faHome } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

interface AuthRequiredProps {
    message?: string;
}

const AuthRequired: React.FC<AuthRequiredProps> = ({
                                                       message
                                                   }) => {
    const { t } = useTranslation();
    const displayMessage = message || t('components.authRequired.defaultMessage');

    return (
        <div className="glass-page-bg flex items-center justify-center">
            <div className="glass-card max-w-md w-full p-8 text-center">
                <div className="text-6xl text-red-500 mb-6">
                    <FontAwesomeIcon icon={faShieldAlt} />
                </div>
                <h2 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-4">
                    {t('components.authRequired.authenticationRequired')}
                </h2>
                <p className="text-gray-600 dark:text-gray-300 mb-6">
                    {displayMessage}
                </p>
                <Link
                    to="/"
                    className="glass-btn-primary inline-flex items-center"
                >
                    <FontAwesomeIcon icon={faHome} className="mr-2" />
                    {t('components.authRequired.goToHome')}
                </Link>
            </div>
        </div>
    );
};

export default AuthRequired;